import React from "react";
import axios from "axios";
import _ from "lodash/fp";
import useForm from "react-hook-form";
import { apiInventario } from "../../../../../config/api.contable";
import {
  Grid,
  FormHelperText,
  Typography,
  CardActions,
  Button,
  DialogContent,
  Dialog,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { notification } from "antd";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  error: {
    color: "red",
  },
});

const ModalEditLocacion = (props) => {
  const classes = useStyles();
  const { visible, setVisible, reload, dataLocacion, setLoading } = props;
  const { register, handleSubmit, errors } = useForm();

  const editCategoria = async (newData) => {
    setLoading(true);
    const dataLoc = {
      name: newData.name.toUpperCase(),
      description: newData.description.toUpperCase(),
    };
    await axios
      .put(`${apiInventario}/update-location/${dataLocacion._id}`, dataLoc)
      .then((res) => {
        notification["success"]({ message: `Se actualizó correctamente.` });
        reload();
        setVisible(false);
      })
      .catch((error) => {
        notification["error"]({
          message: `No se pudo actualizar el registro.`,
          description: `${error}`,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Dialog maxWidth="md" fullWidth open={visible}>
      <DialogTitle>
        <Typography variant="h3">Actualizar Categoria</Typography>
      </DialogTitle>
      <form onSubmit={handleSubmit(editCategoria)} autoComplete="off">
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <TextField
                autoFocus
                label="Nombre"
                variant="outlined"
                fullWidth
                name="name"
                defaultValue={dataLocacion.name}
                inputRef={register({
                  required: true,
                  maxLength: 120,
                })}
              />
              {_.get("name.type", errors) === "required" && (
                <FormHelperText className={classes.error}>
                  El nombre de la categoría es requerido.
                </FormHelperText>
              )}
              {_.get("name.type", errors) === "maxLength" && (
                <FormHelperText className={classes.error}>
                  La longitud máxima de caracteres es 120.
                </FormHelperText>
              )}
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                autoFocus
                label="Description"
                variant="outlined"
                fullWidth
                name="description"
                defaultValue={dataLocacion.description}
                inputRef={register({
                  required: true,
                  maxLength: 120,
                })}
              />
              {_.get("description.type", errors) === "required" && (
                <FormHelperText className={classes.error}>
                  La descipción de la categoría es requerido.
                </FormHelperText>
              )}
              {_.get("description.type", errors) === "maxLength" && (
                <FormHelperText className={classes.error}>
                  La longitud máxima de caracteres es 120.
                </FormHelperText>
              )}
            </Grid>
          </Grid>
        </DialogContent>
        <CardActions>
          <Button
            variant="outlined"
            color="primary"
            onClick={() => setVisible(false)}
          >
            Cancelar
          </Button>
          <Button color="primary" variant="contained" type="submit">
            Actualizar
          </Button>
        </CardActions>
      </form>
    </Dialog>
  );
};

export default ModalEditLocacion;
